// views/Dashboard/PainelExecutivo/areas/AreaFinanceiro.tsx
import React from 'react';
import type { FiltrosDashboard } from '../types';
import SecaoFinanceiro from '../sections/financeiro/SecaoFinanceiro';
import RecebimentoDoMes from '../sections/financeiro/RecebimentoDoMes';
import ProjecaoFaturamento from '../sections/financeiro/ProjecaoFaturamento';
import { useAgendasRecebiveis } from '../../../../src/hooks/useAgendasRecebiveis';

/**
 * A área Financeira inteira: os KPIs de cobrança, a previsão de recebíveis e a
 * linha de base estrutural.
 *
 * A carteira de recebíveis (todas as UCs e 15 meses de faturas) só é buscada
 * quando esta área está aberta — montada no painel corrido, ela carregava
 * sempre, mesmo para quem só queria ver Marketing.
 */
const AreaFinanceiro: React.FC<{ filtros: FiltrosDashboard }> = ({ filtros }) => {
  const recebiveis = useAgendasRecebiveis({ horizonteMeses: 6 });
  const carregando = recebiveis.loading && !recebiveis.carregouUmaVez;

  return (
    <div className="space-y-6">
      <SecaoFinanceiro filtros={filtros} />
      <RecebimentoDoMes
        agendas={recebiveis.agendas ?? []}
        taxaRecebimento={recebiveis.taxaRecebimento ?? { taxa: 0, meses: 0, emitido: 0, recebido: 0, medida: false }}
        loading={carregando}
        erro={recebiveis.erro}
      />
      <ProjecaoFaturamento agendas={recebiveis.agendas ?? []} loading={carregando} erro={recebiveis.erro} />
    </div>
  );
};

export default AreaFinanceiro;
